import React from 'react'
import { lightTheme } from '@rodeo-dev/legos'
import colors from '@rodeo-dev/legos/dist/themes/colors'
import styled from 'styled-components'
import currency from '../../../../lib/currency.jsx'
import TagLabel from './tag-label.js'
import { FlexRow, Attachment, LabelWrap } from './index'

const { palette } = lightTheme
const ExpenseAmount = styled.span`
  position: absolute;
  display: block;
  text-align: right;
  right: ${({ hasDate }) => (hasDate ? '13.5%' : '11.5%')};
`

const ExpenseDescription = styled.span`
  font-size: 13px;
  color: ${colors.text.secondary};
`

const ExpenseDetails = ({ poItem, onClickExpenseInvoiceTag, hasDate }) => {
  if (poItem.expenses && poItem.expenses.length > 0) {
    return poItem.expenses.map((expense, idx) => {
      return (
        <div key={idx}>
          <FlexRow>
            <LabelWrap>
              <TagLabel
                title={expense.invoiceNo || ''}
                type='button'
                backgroundColor={palette.primary.contrastText}
                color={colors.text.secondary}
                onClick={() => onClickExpenseInvoiceTag(expense, poItem)}
              >
                {expense.invoiceNo}
              </TagLabel>
              {expense.filePath && (
                <Attachment
                  target='_blank'
                  rel='noopener noreferrer'
                  href={encodeURI(expense.filePath)}
                >
                  <i className='icon icon-phase-attachment-hover' />
                </Attachment>
              )}
              {expense.description && (
                <ExpenseDescription
                  dangerouslySetInnerHTML={{
                    __html: expense.description || ''
                  }}
                />
              )}
            </LabelWrap>
            <ExpenseAmount hasDate={hasDate}>
              {currency.formatSymbol(expense.amount)}
            </ExpenseAmount>
          </FlexRow>
        </div>
      )
    })
  }

  return ''
}

export default ExpenseDetails
